(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase();

  function findOptionGroup(picker, optionName) {
    return Array.from(picker.querySelectorAll('[data-js-product-variant]'))
      .find((group) => {
        const name = group.querySelector('.product-variant__name');
        return normalize(name?.textContent) === normalize(optionName);
      });
  }

  function getContainer(group) {
    return group?.querySelector('[data-js-product-variant-container]') || null;
  }

  function getSelect(container) {
    if (!container) return null;
    return container.tagName === 'SELECT'
      ? container
      : container.querySelector('select');
  }

  function selectedValue(group) {
    const container = getContainer(group);
    if (!container) return '';

    const select = getSelect(container);
    if (select) return select.value || '';

    const checked = container.querySelector('input[type="radio"]:checked');
    return checked?.value || '';
  }

  function findRadio(group, targetValue) {
    const container = getContainer(group);
    if (!container) return null;

    return Array.from(container.querySelectorAll('input[type="radio"]'))
      .find((input) => normalize(input.value) === normalize(targetValue)) || null;
  }

  function chooseWholeBean(formatGroup) {
    const wholeBeanRadio = findRadio(formatGroup, 'Whole Bean');

    // Trigger Caffeine's own variant-selection handler.
    if (wholeBeanRadio && !wholeBeanRadio.disabled) {
      wholeBeanRadio.click();
      return true;
    }

    const select = getSelect(getContainer(formatGroup));
    const option = select && Array.from(select.options)
      .find((item) => normalize(item.value) === 'whole bean');

    if (option && !option.disabled) {
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  }

  function syncFivePoundAvailability(formatGroup, isFiveLb) {
    const groundRadio = findRadio(formatGroup, 'Ground');

    if (groundRadio) {
      const groundItem = groundRadio.closest('.product-variant__item');

      if (isFiveLb) {
        // The Caffeine "disabled" CSS class does not actually disable a radio.
        groundRadio.disabled = true;
        groundRadio.dataset.cirqueDisabled = 'true';

        // Hide the full visual option, including its label.
        if (groundItem) {
          groundItem.hidden = true;
          groundItem.style.setProperty('display', 'none', 'important');
        }
      } else {
        if (groundRadio.dataset.cirqueDisabled === 'true') {
          groundRadio.disabled = false;
          delete groundRadio.dataset.cirqueDisabled;
        }

        if (groundItem) {
          groundItem.hidden = false;
          groundItem.style.removeProperty('display');
        }
      }
    }

    const select = getSelect(getContainer(formatGroup));
    const groundOption = select && Array.from(select.options)
      .find((item) => normalize(item.value) === 'ground');

    if (groundOption) {
      if (isFiveLb) {
        groundOption.disabled = true;
        groundOption.hidden = true;
        groundOption.dataset.cirqueDisabled = 'true';
      } else if (groundOption.dataset.cirqueDisabled === 'true') {
        groundOption.disabled = false;
        groundOption.hidden = false;
        delete groundOption.dataset.cirqueDisabled;
      }
    }
  }

  function syncProduct(productComponent) {
    const picker = productComponent.querySelector('product-variants');
    const wrapper = productComponent.querySelector('[data-js-grind-property]');
    if (!picker || !wrapper) return;

    const formatGroup = findOptionGroup(picker, 'Coffee Format');
    const weightGroup = findOptionGroup(picker, 'Weight');
    const weight = selectedValue(weightGroup);
    const isFiveLb = /^5\s*lbs?$/i.test(weight.trim());

    // Avoid leaving the theme on an impossible 5 lb / Ground combination.
    if (formatGroup && isFiveLb && normalize(selectedValue(formatGroup)) === 'ground') {
      chooseWholeBean(formatGroup);
    }

    if (formatGroup) {
      syncFivePoundAvailability(formatGroup, isFiveLb);
    }

    // Identify Coffee Format by its label, not by its numeric option position.
    const isGround =
      Boolean(formatGroup) &&
      !isFiveLb &&
      normalize(selectedValue(formatGroup)) === 'ground';

    const grindSelect = wrapper.querySelector('select[name="properties[Grind]"]') ||
      wrapper.querySelector('select[name*="properties["]');

    wrapper.hidden = !isGround;
    wrapper.style.display = isGround ? '' : 'none';
    wrapper.setAttribute('aria-hidden', isGround ? 'false' : 'true');

    if (!grindSelect) return;
    grindSelect.disabled = !isGround;
    grindSelect.required = isGround;

    if (!isGround) {
      grindSelect.value = '';
      const requiredMessage = wrapper.querySelector('.product-variant__required');
      if (requiredMessage) requiredMessage.style.display = 'none';
    }
  }

  function initGrindSelector(wrapper) {
    const productComponent = wrapper.closest('[data-js-product-component]');
    const picker = productComponent?.querySelector('product-variants');
    if (!productComponent || !picker) return;
    if (wrapper.dataset.grindSelectorInitialized === 'true') return;

    wrapper.dataset.grindSelectorInitialized = 'true';

    const sync = () => syncProduct(productComponent);
    const afterThemeUpdate = () => {
      // Caffeine may update variants asynchronously.
      setTimeout(sync, 0);
      setTimeout(sync, 120);
    };

    sync();
    picker.addEventListener('change', afterThemeUpdate);
    picker.addEventListener('VARIANT_CHANGE', afterThemeUpdate);
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-js-grind-property]').forEach(initGrindSelector);
  }

  function init() {
    customElements.whenDefined('product-variants').then(() => initAll());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    customElements.whenDefined('product-variants')
      .then(() => initAll(event.target));
  });
})();
